require('./datePickerPopupController');

"use strict";

angular.module('app.shared.datePickerPopup.datePickerPopupDirective', [
    'app.shared.datePickerPopup.datePickerPopupController'
])
    .directive('datePickerPopup', [
        function () {
            return {
                restrict: 'AE',
                templateUrl: 'components/shared/datePickerPopup/datePickerPopupView.html',
                controller: 'app.shared.datePickerPopup.datePickerPopupController',
                controllerAs: 'vm',
                bindToController: {
                    callback: '&',
                    rangeStart: '@?',
                    rangeEnd: '@?',
                },
                link: postLink,
                scope: {
                    givenDate: '=?',
                    startDate: '=?',
                    disablePopup: '=?'
                },
            };

            function postLink(scope, iElement, iAttrs, vm) {
                scope.$watch(function() {
                    return scope.dt;
                }, function(newValue) {
                    if (angular.isDefined(newValue)  && typeof vm.callback === 'function') {
                        vm.callback({$value: newValue});
                    }
                }, true);
            }
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/shared/datePickerPopup/datePickerPopupDirective.js